import { Download } from "components/icons";
import html2canvas from "html2canvas";
import moment from "moment";
import React, { useRef } from "react";

import CloseIcon from "../../../components/icons/Close";
import ExpandIcon from "../../../components/icons/ExpandIcon";
import LineChart from "./LineChart";
const Chart = (props) => {
  const { chartData, chartLabel, inDrawer, metricsName = "", zoom = false, setZoom } = props;
  const divRef = useRef(null);
  const captureScreenshot = () => {
    var canvasPromise = html2canvas(divRef.current);
    canvasPromise.then((canvas) => {
      var dataURL = canvas.toDataURL();
      var a = document.createElement("a");
      a.target = "_blank";
      a.href = dataURL;
      a.download = `${moment().toISOString()}_${metricsName}.png`;
      a.click();
    });
  };
  return (
    <div className="cs-chart-block" onClick={(e) => e.stopPropagation()} ref={divRef}>
      <div className="d-flex align-items-center justify-content-between mb-2">
        <h4>{chartLabel}</h4>
        {!inDrawer && (
          <span>
            {!zoom ? (
              <button
                style={{ background: "none", border: "none" }}
                title="Expand graph"
                onClick={() => setZoom(metricsName, true)}
              >
                <ExpandIcon />
              </button>
            ) : (
              <div className="d-flex justify-content-between chart-icon-container">
                <button
                  style={{ background: "none", border: "none" }}
                  title="Download graph"
                  onClick={captureScreenshot}
                >
                  <Download />
                </button>
                <button style={{ background: "none", border: "none" }} title="Close" onClick={() => setZoom("", false)}>
                  <CloseIcon />
                </button>
              </div>
            )}
          </span>
        )}
      </div>
      <div className="chart-data-container-items">
        <LineChart chartData={chartData} inDrawer={inDrawer} {...props} />
        {!chartData.labels?.length && <p className="noDataFound-text">No data available</p>}
      </div>
    </div>
  );
};

export default Chart;
